import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "popoverContent", "popoverContainerStyles", "popoverPortalHookId", "popoverPadding", "popoverId", "id", "onClick", "dismissOnClickOutside", "initiallyOpen", "externalIsOpen", "setExternalIsOpen", "placement"];
import { useRef, forwardRef } from 'react';
import styled from 'styled-components';
import { useMenuButton } from '../hooks/useMenuButton';
import Popover from '../../Popover';
import TrackedButton from '../../TrackedButton';
import { Menu } from './Menu';
import withTransientStyleProps from '../../../utils/withTransientStyleProps';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMenu = styled(withTransientStyleProps(Menu)).withConfig({
  displayName: "MenuButton__StyledMenu",
  componentId: "zupdnt-0"
})(["", ""], ({
  $popoverContainerStyles
}) => $popoverContainerStyles);
export const MenuButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      children,
      popoverContent,
      popoverContainerStyles,
      popoverPortalHookId,
      popoverPadding,
      popoverId,
      id,
      onClick,
      dismissOnClickOutside,
      initiallyOpen,
      externalIsOpen,
      setExternalIsOpen,
      placement = 'bottom'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const popoverButtonRef = useRef(null);
  const {
    menuProps,
    buttonProps,
    closeMenu
  } = useMenuButton({
    menuId: popoverId,
    menuButtonId: id,
    hasPopup: true,
    onClick,
    initiallyOpen,
    externalIsOpen,
    setExternalIsOpen
  });
  return /*#__PURE__*/_jsx(Popover, Object.assign({}, menuProps, {
    ref: ref || popoverButtonRef,
    placement: placement,
    dismissOnClickOutside: dismissOnClickOutside,
    content: /*#__PURE__*/_jsx(StyledMenu, {
      id: popoverId,
      menuTriggerId: id,
      closeMenu: closeMenu,
      setFocusOnMount: true,
      shouldManageTabIndex: true,
      $popoverContainerStyles: popoverContainerStyles,
      shouldLoopFocus: true,
      children: popoverContent
    }),
    padding: popoverPadding,
    target: popoverPortalHookId ? document.querySelector(`[data-portal-hook="${popoverPortalHookId}"]`) : undefined,
    children: /*#__PURE__*/_jsx(TrackedButton, Object.assign({}, buttonProps, rest, {
      children: children
    }))
  }));
});